module.exports = __webpack_public_path__ + "img/airbreak.390510d0.png";